import { Select } from "antd";
import type { GetRef, SelectProps } from "antd";
import React from "react";

import { useTranslation } from "react-i18next";

type Props = Pick<SelectProps, "id" | "aria-describedby" | "aria-invalid" | "aria-required" | "onBlur" | "onFocus"> & {
  value?: string;
  onChange?: (value?: string) => void;
};

type OptionLangKey = "ftl_trailer_type_1" | "ftl_trailer_type_2" | "ftl_trailer_type_3";

export const ftlTrailterTypeOptionKeys: Array<OptionLangKey> = ["ftl_trailer_type_1", "ftl_trailer_type_2", "ftl_trailer_type_3"];

const FtlTrailterTypePicker = React.memo(
  React.forwardRef<GetRef<typeof Select>, Props>(function FtlTrailterTypePicker({ onChange, value, ...selectProps }, ref) {
    const { t } = useTranslation("translations");

    // labelToApi - кастыль, в 1С нужно чтобы попадала всегда русское название
    // поэтому с api общаемся русскими строками, а показываем мультиязычные

    const options = React.useMemo<Array<{ value: number; label: string; labelToApi: string }>>(
      () => ftlTrailterTypeOptionKeys.map((x, index) => ({ value: index, label: t(x), labelToApi: t(x, { lng: "ru" }) })),
      [t],
    );

    const handleChange = React.useCallback(
      (id?: number) => {
        if (onChange) {
          onChange(id !== undefined ? options[id].labelToApi : undefined);
        }
      },
      [onChange, options],
    );

    return (
      <Select
        {...selectProps}
        ref={ref}
        value={value ? options.find((x) => x.labelToApi === value)?.value : undefined}
        options={options}
        onChange={handleChange}
        allowClear
      />
    );
  }),
);

export default FtlTrailterTypePicker;
